/**
 * Created by Jerry on 2019/2/22.
 */
export default {
    //baseUrl: "http://192.168.1.217:8080/",
    //测试环境url
    //baseImgUrl: "http://192.168.1.217:80",
     baseUrl: "/apis/",
    // baseImgUrl: "http://exam.china-price.com.cn:82/",
     //baseImgUrl: "http://exam.china-price.com.cn:82/",//准正式环境图片服务器
     //baseUrl: "http://exam.china-price.com.cn:8080",
    baseImgUrl: "http://exam.china-price.com.cn:80", //正式接口
    // baseUrl: "http://192.168.14.115:8080/",
    navList: [
      {
        top: '1',
        left: [
          {
            index: '1-1',
            name: '个人信息',
            icon: 'el-icon-tickets',
            childrens: [
              {
                index: '1-1-1',
                name: '基本信息',
                url: '/basicinfo'
              },
              {
                index: '1-1-2',
                name: '我的照片',
                url: '/mypicture'
              },
              {
                index: '1-1-3',
                name: '我的证件',
                url: '/mycertificate'
              }
            ]
          },
          {
            index: '1-2',
            name: '考试报名',
            icon: 'el-icon-share',
            url: '/enroll',
            childrens: []
          },
          {
            index: '1-3',
            name: '报考信息',
            icon: 'el-icon-document',
            url: '/enrollinfo',
            childrens: []
          },
          {
            index: '1-4',
            name: '打印准考证',
            icon: 'el-icon-printer',
            url: '/printadmissionticket',
            childrens: []
          },
          {
            index: '1-5',
            name: '成绩查询',
            icon: 'el-icon-search',
            url: '/grade',
            childrens: []
          },

        ]
      },
      {
        top: '2',
        left: [
          {
            index: '2-1',
            name: '网站内容编辑',
            icon: 'el-icon-tickets',
            childrens: [
              {
                index: '2-1-1',
                name: '考试政策编辑',
                url: '/exampolicy'
              },
              {
                index: '2-1-2',
                name: '考试动态编辑',
                url: '/examdynamic'
              }
            ]
          },
          {
            index: '2-2',
            name: '考试报名管理',
            icon: 'el-icon-document',
            childrens: [
              {
                index: '2-2-1',
                name: '报名信息发布',
                url: '/examrelease'
              },
              {
                index: '2-2-2',
                name: '报名信息审核',
                url: '/examapproval'
              },
              {
                index: '2-2-3',
                name: '报名人员统计',
                url: '/examstatistics'
              }
            ]
          },
          {
            index: '2-3',
            name: '准考证设置',
            icon: 'el-icon-setting',
            url: '/admissionticket',
            childrens: [
              {
                index: '2-3-2',
                name: '考场列表',
                url: '/examstatistics'
              },
            ]
          },
          {
            index: '2-4',
            name: '考试成绩管理',
            icon: 'el-icon-view',
            childrens: [
              {
                index: '2-4-1',
                name: '成绩录入',
                url: '/scoreinput'
              },
              {
                index: '2-4-2',
                name: '成绩查询',
                url: '/scorequery'
              }
            ]
          },
          {
            index: '2-5',
            name: '证书管理',
            icon: 'el-icon-menu',
            childrens: [
              {
                index: '2-5-1',
                name: '当年获得证书人员',
                url: '/certificategetuser'
              },
              {
                index: '2-5-2',
                name: '待邮寄证书',
                url: '/certificatepost'
              },
              {
                index: '2-5-3',
                name: '办结证书',
                url: '/certificatefinish'
              },
              {
                index: '2-5-4',
                name: '历史获得证书人员',
                url: '/certificatehistory'
              }
            ]
          },
          {
            index: '2-7',
            name: '信息管理',
            icon: 'el-icon-menu',
            childrens: [
              {
                index: '2-7-1',
                name: '短信群发',
                url: '/certificategetuser'
              },
              {
                index: '2-5-2',
                name: '待邮寄证书',
                url: '/certificatepost'
              },
              {
                index: '2-5-3',
                name: '办结证书',
                url: '/certificatefinish'
              },
              {
                index: '2-5-4',
                name: '历史获得证书人员',
                url: '/certificatehistory'
              }
            ]
          },
          {
            index: '2-6',
            name: '系统管理',
            icon: 'el-icon-menu',
            childrens:[
              {
                index: '2-6-1',
                name: ' 用户管理',
                url: '/usermanage'
              },
              {
                index: '2-6-2',
                name: ' 角色管理',
                url: '/rolemanage'
              },
            ]
          }

        ]
      }


    ],
  ueditorToolbar:[[
    'bold', 'italic', 'underline' ,'|',
    'forecolor', 'backcolor', 'insertorderedlist', 'insertunorderedlist', 'fontborder','|',
    'justifyleft', 'justifycenter', 'justifyright', 'justifyjustify', '|',
    'customstyle', 'paragraph','fontfamily', 'fontsize','|',
    'inserttable', 'deletetable', 'insertparagraphbeforetable', 'insertrow',
    'deleterow', 'insertcol', 'deletecol', 'mergecells', 'mergeright', 'mergedown', 'splittocells', 'splittorows', 'splittocols', 'charts', 'insertimage']]

}



// WEBPACK FOOTER //
// ./src/config.js